const S3_BASE_URL = 'https://bizuappimages.s3.amazonaws.com';

export const getRecipeImageUrl = (imageName) => {
  if (!imageName) return null;
  return `${S3_BASE_URL}/recipes/${imageName}`;
};

export const getProductImageUrl = (productName) => {
  if (!productName) return null;
  return `${S3_BASE_URL}/products/${productName}.png`;
};

export const getIngredientImageUrl = (ingredientName) => {
  if (!ingredientName) return null;
  // Normalize ingredient name for S3 path
  const normalizedName = ingredientName.toLowerCase().replace(/\s+/g, '_');
  return `${S3_BASE_URL}/recipes/ingredients/${normalizedName}.png`;
};

export const getBizuImageUrl = (bizuName) => {
  if (!bizuName) return null;
  return `${S3_BASE_URL}/bizus/${bizuName}.gif`;
};
